import { render, staticRenderFns } from "./CriteriaGroupVideoClips.vue?vue&type=template&id=9590d810&scoped=true&"
import script from "./CriteriaGroupVideoClips.vue?vue&type=script&lang=ts&"
export * from "./CriteriaGroupVideoClips.vue?vue&type=script&lang=ts&"
import style0 from "./CriteriaGroupVideoClips.vue?vue&type=style&index=0&id=9590d810&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9590d810",
  null
  
)

export default component.exports